import {Component, inject, OnInit} from '@angular/core';
import {ButtonPadraoComponent} from '../../shared/components/button-padrao/button-padrao.component';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {IdNome} from '../../shared/model/id-nome.model';
import {RotinaService} from '../../shared/service/rotina.service';
import {SelectMultipleComponent} from '../../shared/components/select-multiple/select-multiple.component';
import {ValidacaoAlteracaoCampoService} from '../../shared/service/utilitarios/validacao-alteracao-campo.service';

@Component({
  selector: 'app-modal-associar-perfil-rotina',
  standalone: true,
  imports: [
    ButtonPadraoComponent,
    SelectMultipleComponent
  ],
  templateUrl: './modal-associar-perfil-rotina.component.html',
  styleUrl: './modal-associar-perfil-rotina.component.css'
})
export class ModalAssociarPerfilRotinaComponent implements OnInit {
  rotinas: IdNome[] = [];
  rotinasAssociadas: IdNome[] = [];

  private readonly dialog = inject<MatDialogRef<ModalAssociarPerfilRotinaComponent>>(MatDialogRef);
  private readonly matDialog = inject(MatDialog);
  public data = inject(MAT_DIALOG_DATA);
  private readonly rotinaService = inject(RotinaService);
  public alteracaoService = inject(ValidacaoAlteracaoCampoService);

  ngOnInit() {
    this.rotinasAssociadas = this.data['rotinasAssociadas'];
    this.buscarRotinasSelect();
    this.alteracaoService.camposNaoAlterados();
  }

  buscarRotinasSelect() {
    this.rotinaService.buscarRotinaSelect().subscribe({
      next: res => {
        this.rotinas = res;
        this.rotinasAssociadas = this.rotinas.filter(rot => this.rotinasAssociadas.map(r => r.id).includes(rot.id));
      }
    });
  }

  salvar() {
    this.dialog.close(this.rotinasAssociadas);
  }

  cancelar() {
    this.dialog.close();
  }

}
